module.exports = function() {

  return function(routes, filter) {
    return routes.filter(function(route) {
      var driverNotStarted = route.driverUsername && ! route.timestampStart; // Assigned driver + not startet
      var startedButNotDone = route.timestampStart && ! route.timestampStop;

      var filterNotStarted = filter.status!=='notStarted' || ! route.timestampStart; // With or without driver
      var filterUnfinished = filter.status!=='unfinished' || startedButNotDone;
      var filterDelayed = filter.status!=='delayed' || (!! route.delayForHumans() && (driverNotStarted || startedButNotDone));
      var filterReserved = filter.status!=='reserved' || route.reserved;

      return filterNotStarted && filterUnfinished && filterDelayed && filterReserved;
    });
  };

};



/*****************
 ** WEBPACK FOOTER
 ** ./src/js/filters/fleetRoutes.js
 ** module id = 164
 ** module chunks = 1
 **/